import React, { useState, useEffect } from "react";
import "../M&V/Mv.css";

const Mv = () => {
  const images = ["/mv1.webp", "/mv2.webp", "/mv3.webp"];

  const images2 = ["/mv4.webp", "/mv5.webp", "/mv6.webp"];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex < images.length - 1 ? prevIndex + 1 : 0,
      );
    }, 2000);

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [images.length]);

  return (
    <>
      <div className="about">
        {/* ------------------------------------ */}
        <div className="upper">
          <div className="slider" id="lower-img">
            <img
              src={images2[currentIndex]}
              data-aos="zoom-out-right"
              alt="Image"
              id="slider"
            />
          </div>
          <div className="info" id="lower-info">
            <h1 data-aos="flip-up">OUR VISION</h1>
            <p data-aos="fade-down">
              Medix aspires to be a leading medical agency, recognized for our
              unwavering commitment to quality care, innovation, and patient
              well-being. We achieve this by continuously innovating and
              utilizing cutting-edge technology, implementing best practices in
              healthcare management, and fostering a culture of learning and
              development for our staff. We advocate for preventative healthcare
              and wellness programs, championing ethical and transparent
              practices within the industry. Through these efforts, we strive to
              bridge the gap between patients and exceptional care.
            </p>
          </div>
        </div>
        {/* ------------------------------------ */}
        <div className="lower">
          <div className="info" id="lower-info">
            <h1 data-aos="flip-up">OUR MISSION</h1>
            <p data-aos="fade-down">
              Medix is dedicated to providing exceptional medical services and
              resources to our clients. We believe in fostering a healthier and
              happier community by building strong partnerships with healthcare
              providers, offering a comprehensive range of medical solutions,
              and employing a team of dedicated and qualified professionals.
              Personalized and compassionate care is paramount, while
              affordability and accessibility remain key priorities.
            </p>
          </div>
          <div className="slider" id="lower-img">
            <img
              src={images[currentIndex]}
              data-aos="zoom-out-left"
              alt="Image"
              id="slider"
            />
          </div>
        </div>
        {/* ------------------------------------ */}
      </div>
    </>
  );
};

export default Mv;
